var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"text-extra-large",class:[
		_vm.ALIGNMENT_CLASS[_vm.meta.alignment],
		_vm.SIZE_CLASS[_vm.meta.size] ]},[_vm._v(" "+_vm._s(_vm.meta.mainText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }